const fixed = function (el, binding) {
  const rect = el.parentNode.getBoundingClientRect()
  if (rect.top <= binding.value) {
    if (el.style.position !== 'fixed') {
      const style = {
        position: 'fixed',
        top: binding.value + 'px',
        zIndex: 100
      }
      for (const key in style) {
        el.style[key] = style[key]
      }
    }
  } else {
    el.style = ''
  }
}

const cssSupport = function (attr, value) {
  var element = document.createElement('div')
  if (attr in element.style) {
    element.style[attr] = value
    return element.style[attr] === value
  } else {
    return false
  }
}

const sticky = {
  inserted (el, binding) {
    if (cssSupport('position', 'sticky')) {
      const style = {
        position: 'sticky',
        top: binding.value + 'px',
        zIndex: 100
      }
      for (const key in style) {
        el.style[key] = style[key]
      }
    } else {
      const wrap = document.createElement('div')
      const parent = el.parentNode
      const rect = el.getBoundingClientRect()
      parent.replaceChild(wrap, el)
      wrap.appendChild(el)
      wrap.style.width = rect.width + 'px'
      wrap.style.height = rect.height + 'px'
      window.addEventListener('scroll', () => {
        fixed(el, binding)
      })
    }
  },
  update (el) {
    if (!cssSupport('position', 'sticky')) {
      const wrap = document.createElement('div')
      const parent = el.parentNode
      const rect = el.getBoundingClientRect()
      parent.style.width = rect.width + 'px'
      parent.style.height = rect.height + 'px'
    }
  }
}

export default sticky
